/**
 * Galerie Evolution
 */
$(document).ready(function() {
    /**
     * Evolution
     */
    if($('#porfolio-4').length > 0) {
        $('<div class="photo-separator"></div>').insertBefore($('#photo-140'));
    }

    /**
     * Livre
     */
    $('.issuu').on('click', function(evt) {
        $.popupWindow($(evt.currentTarget).attr('href'), {
            width: screen.width,
            height: screen.height - 14
        });
        return false
    });
});